import {AxiosResponse} from 'axios';
import {setBeersOnTapAC} from 'pages/pubPagesView/store/pubPageSlice';
import {call, put} from 'redux-saga/effects';
import {getAdminPubBeers} from 'services/pubs';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {PubBeer} from 'typescript/models/PubBeer';

import {getAdminBeersOnTapACS} from '../requestAC';

export function* getAdminBeersOnTapSaga(action: ReturnType<typeof getAdminBeersOnTapACS>) {
  try {
    const response: AxiosResponse<ApiData<PubBeer[]>> = yield call(getAdminPubBeers, action.payload);

    yield put(
      setBeersOnTapAC({
        totalPages: response.data.meta.total_pages,
        list: response.data.data,
        totalCount: response.data.meta.total_count,
      }),
    );
  } catch (error) {
    yield call(handleError, error, 'Failed to get pub beers as admin');
  }
}
